/* eslint-disable react/jsx-props-no-spreading */
import Icon from "../Icon";

const CompressSolidV6 = (props) => (
  <Icon {...props} name="Compress Solid V6">
    <path d="M5 10H2a1 1 0 1 0 0 2h2v2a1 1 0 1 0 2 0v-3a1 1 0 0 0-1-1zm9 0h-3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0v-2h2a1 1 0 1 0 0-2zm-3-4h3a1 1 0 1 0 0-2h-2V2a1 1 0 1 0-2 0v3a1 1 0 0 0 1 1zM5 1a1 1 0 0 0-1 1v2H2a1 1 0 1 0 0 2h3a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z" />
  </Icon>
);

export default CompressSolidV6;
